export const GridColumnType = {
    DATE: "DATE",
    CHECKBOX: "CHECKBOX",
    TOGGLE: "TOGGLE",
    LINK: "LINK",
    EMAIL: "EMAIL",
    PHONE: "PHONE",
    ACTION: "ACTION",
    ICON: "ICON",
    BADGE: "BADGE"
};